<template>
    
    <div class="csearch-container">
        
        <SearchHeader />

        <div class="search-top-info" >
            
            <div v-if="isDefault" style="height: 4rem">
                {{ defaultMessage }}
            </div>

            <div v-else style="height: 5rem">
                2021年，南沙高新技术企业达744家，是2015年的近10倍。据南财金种子企业库数据显示，南沙拥有瞪羚企业260家，专精特新企业89家。其中，有85家企业既属于全国瞪羚企业，也属于专精特新企业。
            </div>
        </div>

        <CustomBox style="margin-top: 30px">

            <SearchTop />

            <SearchBottom v-if="tOption && tOption.type == 4" />
        </CustomBox>
    </div>
</template>

<script>

    import { mapState } from "vuex";

    import SearchHeader from "@/components/SearchHeader";
    import SearchTop from "@/components/SearchTop";
    import SearchBottom from "@/components/SearchBottom";
    import CustomBox from "@/components/CustomBox";

    export default {
        name: "CSearch",
        components: {
            SearchHeader,
            SearchTop,
            SearchBottom,
            CustomBox
        },
        data() {

            return {
                defaultMessage: "国务院印发《广州南沙深化面向世界的粤港澳全面合作总体方案》，提出要建设科技创新产业合作基地，强化粤港澳科技联合创新、打造重大科技创新平台、培育发展高新技术产业。"
            };
        },
        computed: {
            ...mapState(["tOption"]),
            isDefault() {

                if (!this.tOption) {
                    return true;
                }

                const { type } = this.tOption;

                return type !== 4;
            }
        },
        mounted() {
            this.resetDropdown();
        },
        methods: {
            resetDropdown() {

                const that = this;

                window.addEventListener("click", () => {
                    that.$store.commit("toggleEDropdown", false);
                    that.$store.commit("toggleIDropdown", false);
                });
            }
        }
    };
</script>

<style lang="scss" scoped>

    .csearch-container {

        background-color: #00057D;
        padding-bottom: 0rem;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow-y: auto;

        .search-top-info {
            color: #45d7f4;
            margin: 1rem;
        }
    }

    .csearch-container::-webkit-scrollbar {
        display: none;
    }
</style>